import { Box, Tabs, Tab, Divider } from '@mui/material'
import { useState } from 'react'
import { CodeDetailsContainerProps } from '../../models/Validation'
import { GroupedTabContent } from './GroupedTabContent'
import { IndividualTabContent } from './IndividualTabContent'

const CodeDetailsContainer = ({
  codeGroups,
  buildingData,
}: CodeDetailsContainerProps) => {
  const [tab, setTab] = useState(0)

  return (
    <Box mt={1} sx={{ width: '100%', height: '100%' }}>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          mb: 2,
          minHeight: 41,
          background: '#F5F5F5',
          '& .MuiTab-root.Mui-selected': {
            backgroundColor: '#1705E5',
            color: '#fff',
          },
          '& .MuiTabs-indicator': {
            display: 'none',
          },
        }}
        variant='fullWidth'
      >
        <Tab
          label='Grouped Codes'
          sx={{
            borderRadius: 1,
            minWidth: 160,
            minHeight: 27,
            textTransform: 'none',
          }}
        />
        <Tab
          label='Individual Codes'
          sx={{
            borderRadius: 1,
            minWidth: 160,
            minHeight: 27,
            textTransform: 'none',
          }}
        />
      </Tabs>
      <Divider sx={{ mb: 2, border: '1px solid', borderColor: '#E0E0E0' }} />
      <Box sx={{ borderRadius: 2, width: '100%', height: '85%' }}>
        {tab === 0 && (
          <GroupedTabContent
            codeGroups={codeGroups}
            buildingData={buildingData}
          />
        )}
        {tab === 1 && <IndividualTabContent codeGroups={codeGroups} />}
      </Box>
    </Box>
  )
}

export default CodeDetailsContainer
